import React from 'react';

const Footer = () => <span />;
export default Footer;
